/** @format */
import {
    FilterQuery,
    SearchListingModel,
    SearchListingProduct,
} from '@toucan/common/services/search/types';

import { DataLayerEventType } from '@toucan/client/global/analytics';

import { trackViaDataLayer } from '@toucan/client/shared/helpers/analytics';

type SearchResultsDataLayerParams = {
    searchResults: (SearchListingProduct | SearchListingModel)[];
    // eslint-disable-next-line @mpb-com/mpb/prefer-enum-over-string-union -- Legacy code: do not use as an example.
    pageType: 'category' | 'brand' | 'model' | 'faceted' | 'search';
    // eslint-disable-next-line @mpb-com/mpb/prefer-enum-over-string-union -- Legacy code: do not use as an example.
    searchVariant: 'product' | 'model';
    searchFilters: FilterQuery;
    sortedBy: string;
    page?: number;
};

export function addSearchResultsToDataLayer({
    searchResults,
    pageType,
    searchVariant,
    searchFilters,
    sortedBy,
    page,
}: SearchResultsDataLayerParams) {
    const results = searchResultsToIds(searchResults, searchVariant);
    const event = DataLayerEventType.SEARCH_RESULTS;
    const filters = searchFiltersToDataLayerFilters(searchFilters);

    trackViaDataLayer({
        event,
        pageType,
        searchVariant,
        results,
        filters,
        sortedBy,
        ...(page !== undefined && { page }),
    });
}

function searchResultsToIds(
    results: SearchResultsDataLayerParams['searchResults'],
    searchVariant: SearchResultsDataLayerParams['searchVariant']
) {
    return results
        .map((result) => {
            switch (searchVariant) {
                case 'model':
                    return result.modelId?.values?.[0];
                case 'product':
                    return result.productSku?.values?.[0];
            }
        })
        .filter(Boolean)
        .join(',');
}

function searchFiltersToDataLayerFilters(
    searchFilters: SearchResultsDataLayerParams['searchFilters']
) {
    return Object.entries(searchFilters).map<{
        name: string;
        value: unknown;
    }>(([key, value]) => ({
        name: key,
        value,
    }));
}
